import { render, staticRenderFns } from "./KycAddressDetails.vue?vue&type=template&id=234fb837&scoped=true&"
import script from "./KycAddressDetails.vue?vue&type=script&lang=js&"
export * from "./KycAddressDetails.vue?vue&type=script&lang=js&"
import style0 from "./KycAddressDetails.vue?vue&type=style&index=0&id=234fb837&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234fb837",
  null
  
)

export default component.exports